import React, { useEffect, useState } from "react";
import { Get_One_From_MongoDB } from "../../api/Get_One_From_MongoDB";
import { ConsultantuseAuth } from "../../security/ConsultantUseAuth";
import { Consultant_Update_To_MongoDB_By_ID } from "../../api/Consultant_Update_To_MongoDB_By_ID";
import { Get_One_Choose_Fields_From_MongoDB } from "../../../Public/api/Get_One_Choose_Fields_From_MongoDB";

function ConsultantSettings() {
  const { logoutConsultant } = ConsultantuseAuth();

  //------------------------------------------Width Stuff

  let widthLimit = 1000;
  const [screenWidth, setscreenWidth] = useState(
    window.innerWidth <= widthLimit ? "Small" : "Big"
  );

  useEffect(() => {
    const handleResize = () => {
      setscreenWidth(window.innerWidth <= widthLimit ? "Small" : "Big");
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  function isMobile() {
    return (
      /Mobi|Android|iPhone|iPad|iPod|BlackBerry|Opera Mini|IEMobile|WPDesktop/i.test(
        navigator.userAgent
      ) || screenWidth === "Small"
    );
  }

  ///--------------------GET  DATA--------

  const [obj_EC, setobj_EC] = useState({});
  useEffect(() => {
    const fetchECData = async () => {
      Get_One_From_MongoDB(
        "IP",
        "EC",
        localStorage.getItem("Consultant_id"),
        setobj_EC,
        logoutConsultant
      );
    };
    fetchECData();
  }, []);
  const [obj_Agency, setobj_Agency] = useState({});
  useEffect(() => {
    if (obj_EC.MetaData?.Agency_id && obj_EC.MetaData.Agency_id.length > 0) {
      Get_One_Choose_Fields_From_MongoDB(
        "IP",
        "Agencies",
        obj_EC.MetaData.Agency_id,
        {
          "MetaData.IP_id": 1,
          _id: 1,
          BasicInfo: 1,
        },
        setobj_Agency
      );
    }
  }, [obj_EC]);
  const [obj_IP, setobj_IP] = useState({});
  useEffect(() => {
    if (obj_Agency.MetaData?.IP_id && obj_Agency.MetaData.IP_id.length > 0) {
      Get_One_Choose_Fields_From_MongoDB(
        "Staff",
        "Users",
        obj_Agency.MetaData.IP_id,
        {
          Username: 1,
          _id: 1,
        },
        setobj_IP
      );
    }
  }, [obj_Agency]);

  ///-----------------------------------

  function handleInfoChange(e, nest) {
    setobj_EC({
      ...obj_EC,
      [nest]: { ...obj_EC[nest], [e.target.name]: e.target.value },
    });
  }

  const [status, setStatus] = useState(false);
  function handleSave(e) {
    e.preventDefault();
    let id = obj_EC._id;
    let data = obj_EC;
    delete data._id;
    console.log("Saving Data: ", data);
    // Save data to MongoDB
    Consultant_Update_To_MongoDB_By_ID(
      data,
      "IP",
      "EC",
      setStatus,
      id,
      logoutConsultant
    );
    data._id = id;
  }

  //BasicFields
  let BasicFields = [
    {
      label: "First_Name",
      Title: "First_Name",
      nested: "BasicInfo",
      disabled: false,
      Type: "text",
      defaultValue: "",
    },
    {
      label: "Last_Name",
      Title: "Last Name",
      nested: "BasicInfo",
      disabled: false,
      Type: "text",
      defaultValue: "",
    },
    {
      label: "Email",
      Title: "Email (Cannot be changed without Admin Approval)",
      nested: "BasicInfo",
      disabled: true,
      Type: "text",
      defaultValue: "",
    },
    {
      label: "Number",
      Title: "Number",
      nested: "BasicInfo",
      disabled: false,
      Type: "number",
      defaultValue: "",
    },
    {
      label: "Admin",
      Title:
        "Admin: See activity for everyone working at " +
        obj_Agency.BasicInfo?.Name +
        ", Can only be updated by InvestIN Staff",
      nested: "MetaData",
      disabled: true,
      Type: "text",
      defaultValue: "No",
    },
  ];

  let AgencyFields = [
    {
      label: "Name",
      Title: "Name",
      nested: "BasicInfo",
      disabled: false,
    },
    {
      label: "Address",
      Title: "Address",
      nested: "BasicInfo",
      disabled: false,
    },
    {
      label: "Address_Line_2",
      Title: "Address Line 2",
      nested: "BasicInfo",
      disabled: false,
    },
    {
      label: "City",
      Title: "City",
      nested: "BasicInfo",
      disabled: false,
    },
    {
      label: "PostCode",
      Title: "PostCode",
      nested: "BasicInfo",
      disabled: false,
    },
    {
      label: "Country",
      Title: "Country",
      nested: "BasicInfo",
      disabled: false,
    },
  ];

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <h1 style={{ textAlign: "center" }}>
        <br></br>Settings
      </h1>
      {/* // */}
      <div
        style={{
          border: "1px solid #ccc",
          padding: "20px",
          borderRadius: "8px",
          width: screenWidth === "Small" ? "90%" : "50%",
          marginTop: "20px",
        }}
      >
        <h2 style={{ textAlign: "center" }}>Your Information</h2>
        {BasicFields.map((field) => (
          <div style={{ marginBottom: "10px" }} key={field.label}>
            <label htmlFor={field.label}>{field.Title}:</label>
            <input
              type={field.Type ? field.Type : "text"}
              id={field.label}
              name={field.label}
              style={{ width: "100%" }}
              disabled={field.disabled}
              value={
                obj_EC[field.nested] && obj_EC[field.nested][field.label]
                  ? obj_EC[field.nested][field.label]
                  : field.defaultValue
              }
              onChange={(e) => handleInfoChange(e, field.nested)}
            />
          </div>
        ))}
      </div>
      {/* // */}
      <div
        style={{
          border: "1px solid #ccc",
          padding: "20px",
          borderRadius: "8px",
          width: screenWidth === "Small" ? "90%" : "50%",
          marginTop: "20px",
        }}
      >
        <h2 style={{ textAlign: "center" }}>Enrolment Form Customisation</h2>
        <div style={{ marginBottom: "10px" }}>
          <label htmlFor={"Welcome_Text"}>
            Welcome Text to appear at the top of the page:
          </label>
          <input
            type="text"
            id="Welcome_Text"
            name="Welcome_Text"
            style={{ width: "100%" }}
            disabled={false}
            value={
              obj_EC.EnrolmentFormSettings &&
              obj_EC.EnrolmentFormSettings.Welcome_Text
                ? obj_EC.EnrolmentFormSettings.Welcome_Text
                : "In Partnership with " +
                  obj_EC?.BasicInfo?.First_Name +
                  " " +
                  obj_EC?.BasicInfo?.Last_Name
            }
            onChange={(e) => handleInfoChange(e, "EnrolmentFormSettings")}
          />
        </div>
        <div style={{ marginBottom: "10px" }}>
          <label htmlFor={"Gross_Or_Net"}>
            {
              "Allow users to choose Gross Or Net on the form, or set all repsonses to a defualt value"
            }
            :
          </label>
          <select
            id="Gross_Or_Net"
            name="Gross_Or_Net"
            style={{ width: "100%" }}
            disabled={false}
            value={
              obj_EC.EnrolmentFormSettings &&
              obj_EC.EnrolmentFormSettings.Gross_Or_Net
                ? obj_EC.EnrolmentFormSettings.Gross_Or_Net
                : ""
            }
            onChange={(e) => handleInfoChange(e, "EnrolmentFormSettings")}
          >
            <option value="">Select an option</option>
            <option value="Allow_Choice">Allow Choice</option>
            <option value="Gross_Only">Gross Only</option>
            <option value="Net_Only">Net Only</option>
          </select>
        </div>
      </div>
      {/* // */}
      <div
        style={{
          border: "1px solid #ccc",
          padding: "20px",
          borderRadius: "8px",
          width: screenWidth === "Small" ? "90%" : "50%",
          marginTop: "20px",
        }}
      >
        <h2 style={{ textAlign: "center" }}>Your Agency Information</h2>
        {AgencyFields.map((field) => (
          <div style={{ marginBottom: "10px" }} key={field.label}>
            <label htmlFor={field.label}>{field.Title}:</label>
            <input
              type={field.Type ? field.Type : "text"}
              id={field.label}
              name={field.label}
              style={{ width: "100%" }}
              disabled={true}
              value={
                obj_Agency[field.nested] &&
                obj_Agency[field.nested][field.label]
                  ? obj_Agency[field.nested][field.label]
                  : ""
              }
            />
          </div>
        ))}
      </div>
      {/* // */}
      <div
        style={{
          border: "1px solid #ccc",
          padding: "20px",
          borderRadius: "8px",
          width: screenWidth === "Small" ? "90%" : "50%",
          marginTop: "20px",
        }}
      >
        <h2 style={{ textAlign: "center" }}>Your InvestIN Contact</h2>
        <div style={{ marginBottom: "10px" }} key={obj_IP.Username}>
          <label htmlFor={obj_IP.Username}>{obj_IP.Username}</label>
          <input
            type={obj_IP.Username ? obj_IP.Username : "text"}
            id={obj_IP.Username}
            name={obj_IP.Username}
            style={{ width: "100%" }}
            disabled={true}
            value={obj_IP.Username || ""}
          />
        </div>
      </div>
      {/* // */}
      <div
        style={{
          border: "1px solid #ccc",
          padding: "20px",
          borderRadius: "8px",
          width: screenWidth === "Small" ? "90%" : "50%",
          marginTop: "20px",
        }}
      >
        {Object.keys(obj_EC).length === 0 ? (
          <></>
        ) : (
          <button
            style={{ width: "100%", padding: "10px", marginTop: "10px" }}
            onClick={(e) => handleSave(e)}
          >
            Save
          </button>
        )}
      </div>
    </div>
  );
}

export default ConsultantSettings;
